<script lang="ts" setup>
import { ref } from 'vue';
import { requirejs } from '~/modules/require';

import VuSpinner from '@v/components/vu-spinner.vue';

import { readCookie } from '~/modules/cookies-services';
import SideButton from '~/components/SideButton.vue';
import { useTracker } from '~/composables/tracker';

const loading = ref(false);
const tracker = useTracker();

const pullUntilTchatIsDisplayed = () =>
  new Promise((resolve) => {
    (function pull() {
      if (document.querySelector('.yui-panel-container')) {
        return resolve('');
      }

      setTimeout(pull, 200);
    }).call(this);
  });

const loadTchat = async () => {
  const panel: HTMLElement | null = document.querySelector('.yui-panel-container');

  tracker?.event('tchat_clicked', 'display', 'CLICK');

  if (panel && panel.parentElement) {
    window.dsLang = readCookie('swymlang') || 'en';

    const body: HTMLElement | null = document.querySelector('body');

    panel.parentElement.style.display = 'block';
    panel.style.visibility = 'visible';

    body?.classList.toggle('hide-tchat');

    return;
  }

  loading.value = true;

  // Load Tchat
  const [SupportChat, MP3DPFeatureToggleRouter, MP3DPRouting] = await requirejs<[any, any, any]>([
    'DS/MPFSupportChat/SupportChat',
    'DS/MP3DPSettings/MP3DPFeatureToggleRouter',
    'DS/MP3DPSettings/MP3DPRouting',
  ]);
  SupportChat.run({
    isProduction: !MP3DPFeatureToggleRouter.isFeatureEnabled('debugChat'),
    deniedPaths: MP3DPRouting.getDeniedUrlsRegexForChat(),
  });

  pullUntilTchatIsDisplayed().then(() => {
    const element: HTMLElement | null = document.querySelector(
      '.yui-panel-container .container-close',
    );
    const body: HTMLElement | null = document.querySelector('body');
    const doNotAskAgain: HTMLElement | null = document.querySelector(
      '.yui-panel-container .rn_RefuseDiv',
    );

    element?.addEventListener('click', () => {
      body?.classList.toggle('hide-tchat');
      loading.value = false;
    });

    if (doNotAskAgain) {
      doNotAskAgain.classList.add('hidden');
    }
  });
};
</script>
<template>
  <SideButton
    id="tchat"
    aria-label="Call for Help of 3ds support"
    name="tchat-btn"
    @click="loadTchat"
  >
    <vu-spinner v-if="loading" />
    <span v-else class="fonticon fonticon-comment-question" />
  </SideButton>
</template>
<style>
.yui-panel-container {
  bottom: 22px !important;
}
</style>
